import React from 'react';
import { useDispatch } from 'react-redux';
import { Button, Grid } from '@mui/material';

import { Icon, useSettings } from 'app/main/components';
import { DetailsSectionWrapper } from 'app/main/components/page-layouts';
import { showFastAddDialog } from 'app/main/modules/components/FastAddDialog';
import { showImportablesDialog } from 'app/main/components/importables/ImportablesDialog';

import CommercialCampaignsRowsAddSingleDialog from '../../commercialcampaigns-rows/CommercialCampaignsRowsAddSingleDialog';
import CommercialCampaignsRowsAddFilterDialog from '../../commercialcampaigns-rows/CommercialCampaignsRowsAddFilterDialog';
import CommercialCampaignsRowsAddQueryDialog from '../../commercialcampaigns-rows/CommercialCampaignsRowsAddQueryDialog';
import CommercialCampaignsRowsImportDialog from '../../commercialcampaigns-rows/CommercialCampaignsRowsImportDialog';

interface CommercialCampaignsDetailsSectionAddNewRowProps {
	cmcpUid: string;
	table: string;
	isLoading: boolean;
	updateRefresh: VoidFunction;
}

export default function CommercialCampaignsDetailsSectionAddRows(
	props: CommercialCampaignsDetailsSectionAddNewRowProps
) {
	const dispatch = useDispatch();
	const { settings, t } = useSettings(props.table);

	const [openAddRowDialog, setOpenAddRowDialog] = React.useState(false);
	const switchOpenAddRowDialog = () => setOpenAddRowDialog(state => !state);

	const [openAddFilterRowsDialog, setOpenAddFilterRowsDialog] = React.useState(false);
	const switchOpenAddFilterRowsDialog = () => setOpenAddFilterRowsDialog(state => !state);

	const [openAddQueryRowsDialog, setOpenAddQueryRowsDialog] = React.useState(false);
	const switchOpenAddQueryRowsDialog = () => setOpenAddQueryRowsDialog(state => !state);

	const [openImportDialog, setOpenImportDialog] = React.useState(false);
	const switchOpenImportDialog = () => setOpenImportDialog(state => !state);

	const showAddDialog = () => {
		dispatch(
			showFastAddDialog({
				module: props.table,
				model: { [`${settings.modu_short}_cmcp_uid`]: props.cmcpUid },
				updateRefresh: props.updateRefresh
			})
		);
	};

	const showImportFileDialog = () =>
		dispatch(
			showImportablesDialog({
				module: 'commercialcampaigns_rows',
				params: { cmcp_uid: props.cmcpUid },
				updateRefresh: props.updateRefresh
			})
		);

	return (
		<>
			<DetailsSectionWrapper
				classes={{ content: 'py-0 last:py-0' }}
				title={t('COMMERCIALCAMPAIGNS_SECTION_ADD_TITLE')}
				actions={
					<Grid container>
						<Grid size={12}>
							<Button
								startIcon={<Icon icon="new-box" />}
								onClick={showAddDialog}
								disabled={props.isLoading}
							>
								{t('VIEW_HEADER_BUTTON_NEW')}
							</Button>
							<Button
								startIcon={<Icon icon="file-upload" />}
								onClick={showImportFileDialog}
								disabled={props.isLoading}
							>
								{t('IMPORT_FILE')}
							</Button>
						</Grid>
						<Grid size={12}>
							<Button
								startIcon={<Icon icon="search" />}
								onClick={switchOpenAddRowDialog}
								disabled={props.isLoading}
							>
								{t('SEARCH_BUTTON')}
							</Button>
							<Button
								startIcon={<Icon icon="filter" />}
								onClick={switchOpenAddFilterRowsDialog}
								disabled={props.isLoading}
							>
								{t('FILTER_BUTTON')}
							</Button>
							<Button
								startIcon={<Icon icon="file-tree" />}
								onClick={switchOpenAddQueryRowsDialog}
								disabled={props.isLoading}
							>
								{t('FILTER_QUERY_BUILDER_BUTTON')}
							</Button>
							<Button
								startIcon={<Icon icon="table-import" />}
								onClick={switchOpenImportDialog}
								disabled={props.isLoading}
							>
								{t('IMPORT_BUTTON')}
							</Button>
						</Grid>
					</Grid>
				}
			>
				{t(`COMMERCIALCAMPAIGNS_SECTION_ADD_DESCRIPTION_${props.table}`)}
			</DetailsSectionWrapper>
			{/* ADD SINGLE ROW DIALOG */}
			<CommercialCampaignsRowsAddSingleDialog
				openDialog={openAddRowDialog}
				switchOpenDialog={switchOpenAddRowDialog}
				cmcpUid={props.cmcpUid}
				table={props.table}
				updateRefresh={props.updateRefresh}
			/>
			{/* ADD ROWS FILTER DIALOG */}
			<CommercialCampaignsRowsAddFilterDialog
				openDialog={openAddFilterRowsDialog}
				switchOpenDialog={switchOpenAddFilterRowsDialog}
				cmcpUid={props.cmcpUid}
				table={props.table}
				updateRefresh={props.updateRefresh}
			/>
			{/* ADD ROWS ADVANCED FILTER DIALOG */}
			<CommercialCampaignsRowsAddQueryDialog
				openDialog={openAddQueryRowsDialog}
				switchOpenDialog={switchOpenAddQueryRowsDialog}
				cmcpUid={props.cmcpUid}
				table={props.table}
				updateRefresh={props.updateRefresh}
			/>
			{/* IMPORT ROWS DIALOG */}
			<CommercialCampaignsRowsImportDialog
				openDialog={openImportDialog}
				switchOpenDialog={switchOpenImportDialog}
				cmcpUid={props.cmcpUid}
				table={props.table}
				updateRefresh={props.updateRefresh}
			/>
		</>
	);
}
